var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._l((_vm.tags),function(tag){return _c('v-chip',{key:tag,staticClass:"ma-2",attrs:{"small":"","color":_vm.getColor(tag)}},[_vm._v(" "+_vm._s(tag)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }